import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import LayoutProvider from "./context/LayoutContext";
import { DynamicThemeProvider } from "./DynamicThemeContext";
import { SettingsProvider } from "./context/SettingsContext";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import { Snackbar, GlobalStyles } from "@mui/material";
import { useState } from "react";
import { setToastHandler } from "./utils/toast";
import { Box } from "@mui/system";
import AraChatbot from "./pages/Chat/AraChatbot";

// eslint-disable-next-line no-unused-vars
function ChatbotWrapper() {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/chat")) return null;
  return <AraChatbot />;
}

export default function App() {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
    duration: 2800,
  });

  setToastHandler((message, severity = "success", opts = {}) => {
    setSnack({ open: true, message, severity, duration: opts.duration || 2800 });
  });

  return (
    <BrowserRouter>
      <DynamicThemeProvider>
        <GlobalStyles
          styles={(theme) => ({
            "*::-webkit-scrollbar": {
              width: "8px",
              height: "8px",
            },
            "*::-webkit-scrollbar-track": {
              background: theme.palette.background.default,
            },
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.primary.main,
              borderRadius: "8px",
            },
            "*::-webkit-scrollbar-thumb:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
            "*": {
              scrollbarWidth: "thin",
              scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.default}`,
            },
          })}
        />

        <AuthProvider>
          <SettingsProvider>
            <LayoutProvider>
              <AppRoutes />
              {/* <ChatbotWrapper /> */}

              <Snackbar
                open={snack.open}
                autoHideDuration={snack.duration}
                onClose={() => setSnack((s) => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                TransitionProps={{ timeout: 350 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    px: 2.8,
                    py: 1.4,
                    minWidth: 320,
                    borderRadius: 2,
                    boxShadow: 4,

                    // SOLID theme primary color
                    bgcolor: (theme) => theme.palette.primary.main,
                    color: (theme) => theme.palette.primary.contrastText,

                    animation: "snackSlideIn 0.35s cubic-bezier(.4,0,.2,1)",
                  }}
                >
                  <Box sx={{ fontSize: 24, display: "flex" }}>
                    {snack.severity === "success" && <CheckCircleIcon />}
                    {snack.severity === "error" && <ErrorIcon />}
                    {snack.severity === "warning" && <WarningIcon />}
                    {snack.severity === "info" && <InfoIcon />}
                  </Box>

                  <Box sx={{ fontWeight: 700 }}>{snack.message}</Box>
                </Box>
              </Snackbar>
            </LayoutProvider>
          </SettingsProvider>
        </AuthProvider>
      </DynamicThemeProvider>
    </BrowserRouter>
  );
}
